import React, { useState } from 'react';
import Select from 'react-select';

import { confService } from '../../../Services';

import {ReactComponent as Loading} from '../../../images/icons/General/loading-01.svg';

const LocationDetails = ({ data, changeValue, changeSelectValue, locationId, staffList, decompressionList, gearsList, gasMixturesList, classificationsList, modules }) => {
    const [staff, setStaff] = useState(staffList && data.staff ? staffList.filter(item => data.staff.split(',').includes(item.value.toString())) : '');
    const [decompressionPlanning, setDecompressionPlanning] = useState(decompressionList && data.decompressionPlanning ? decompressionList.filter(item => item.value === data.decompressionPlanning) : '');
    const [gears, setGears] = useState(gearsList && data.gear ? gearsList.filter(item => item.value === data.gear) : '');
    const [gasMixtures, setGasMixtures] = useState(gasMixturesList && data.gasMixture ? gasMixturesList.filter(item => item.value === data.gasMixture) : '');
    const [classifications, setClassifications] = useState(classificationsList && data.classification ? classificationsList.filter(item => item.value === data.classification) : '');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
     
    const handleSubmit = async (event) => {
        event.preventDefault();
        
        setError('');
        setSuccess(false);
        setLoading(true);

        let message = '';

        if (!data.Location)
            message = 'Please, enter required fields';

        if (!message && modules.indexOf('Dive incidents') >= 0 && data.commProblemNotification) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const invalidEmails = data.commProblemNotification
                .split(',')
                .map(email => email.trim())
                .filter(email => email && !emailRegex.test(email));

            if (invalidEmails.length > 0)
                message = `Invalid email(s) in Comm Problem notification receivers: ${invalidEmails.join(', ')}`;
        }

        if (!message) {
            const res = await confService.editLocation(data);

            if (res.res === 'OK') {
                setSuccess(true);
            } else {
                setError(res.error);
            }
        } else {
            setError(message);
        }
        setLoading(false);
    }

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    return (
        <>  
            <form onSubmit={handleSubmit}>
                <div className="form-column">
                    <label>Name</label>
                    <input type="text" name="Location" value={data.Location || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                </div>
                <div className="form-column">
                    <label>Depth</label>
                    <input type="number" name="Depth" value={data.Depth || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} step="1" />
                </div>
                <div className="form-column">
                    <label>Requires specific location</label>
                    <div className="switch">
                        <input type="checkbox" name="SpecificLocation" checked={data.SpecificLocation || false} onChange={(e) => changeValue(e.target.name, e.target.checked)} id="SpecificLocation" />
                        <label htmlFor="SpecificLocation"></label>
                    </div>
                </div>
                {modules.indexOf('OM Staff') >= 0 &&
                    <div className="form-column">
                        <label>Staff</label>
                        <Select className={`select`} options={staffList} onChange={(value) => changeSelectValue('staff', value, setStaff)} isMulti={true} styles={customStyles} required value={staff} />
                    </div>
                }
                {modules.indexOf('Dive incidents') >= 0 &&
                    <div className="form-column">
                        <label>Comm Problem notification recipients</label>
                        <textarea 
                            name="commProblemNotification"
                            value={data.commProblemNotification || ''}
                            onChange={(e) => changeValue(e.target.name, e.target.value)}
                            maxLength={1000}
                            rows="1"
                            placeholder="e.g. john@example.com, jane@example.com"
                         />
                    </div>
                }
                {modules.indexOf('Location defaults') >= 0 && <>
                    <div className="form-column">
                        <label>Default decompression planning</label>
                        <Select className={`select`} options={decompressionList} onChange={(value) => changeSelectValue('decompressionPlanning', value, setDecompressionPlanning)} styles={customStyles} required value={decompressionPlanning} isClearable />
                    </div>
                    <div className="form-column">
                        <label>Default dive mode</label>
                        <Select className={`select`} options={gearsList} onChange={(value) => changeSelectValue('gear', value, setGears)} styles={customStyles} required value={gears} isClearable />
                    </div>
                    <div className="form-column">
                        <label>Default breathing gas</label>
                        <Select className={`select`} options={gasMixturesList} onChange={(value) => changeSelectValue('gasMixture', value, setGasMixtures)} styles={customStyles} required value={gasMixtures} isClearable />
                    </div>
                    <div className="form-column">
                        <label>Default classification</label>
                        <Select className={`select`} options={classificationsList} onChange={(value) => changeSelectValue('classification', value, setClassifications)} styles={customStyles} required value={classifications} isClearable />
                    </div>
                </>}
                <div className="form-submit">
                    <button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Save</button>
                    {error ? <div className="error">{error}</div> : ''}
                    {success ? <div className="success">Location was successfully {data.LocationID ? 'updated' : 'added'}</div> : ''}
                </div>
            </form>
        </>
    )
}

export default LocationDetails;